<template>
  <component :is="projectData === undefined ? 'div' : 'b-card'">
    <b-alert variant="danger" :show="projectData === undefined">
      <h4 class="alert-heading">獲取項目數據時出錯</h4>
      <div class="alert-body">
        找不到相關項目記錄。請查看
        <b-link class="alert-link" :to="{ name: 'projects-list' }">
          項目名單
        </b-link>
      </div>
    </b-alert>

    <project-edit-tab-information
      v-if="projectData"
      :project-statuses-options="projectStatusesOptions"
      :payment-method-options="paymentMethodOptions"
      :customer-options="customerOptions"
      :quotation-options="quotationOptions"
      :invoice-options="invoiceOptions"
      :project-data="projectData"
      :product-options="productOptions"
      :product-unit-options="productUnitOptions"
      :product-categories-options="productCategoriesOptions"
      :stage-options="stageOptions"
      :user-options="userOptions"
      :loading="loading"
      @refetch-data="refetchData"
      class="p-sm-2"
    />

  </component>
</template>

<script>
import { BCard, BAlert, BLink, BTabs, BTab } from "bootstrap-vue";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import store from "@/store";
import router from "@/router";
import projectStoreModule from "../projectStoreModule";
import ProjectEditTabInformation from "./projectEditTabInformation.vue";

export default {
  components: {
    ProjectEditTabInformation,
    BCard,
    BAlert,
    BTabs,
    BTab,
    BLink,
  },
  setup() {
    const projectData = ref({id: 0});
    const loading = ref(false);
    const project = {
      id: 0,
      deposite: 0,
      // invoice_id: 0,
      project_status_id:3,
      cost_items:[{id:0}]
    };

    const PROJECT_APP_STORE_MODULE_NAME = "project";

    if (!store.hasModule(PROJECT_APP_STORE_MODULE_NAME))
      store.registerModule(PROJECT_APP_STORE_MODULE_NAME, projectStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(PROJECT_APP_STORE_MODULE_NAME))
        store.unregisterModule(PROJECT_APP_STORE_MODULE_NAME);
    });

    const refetchData = () => {
      loading.value = true;
      if (router.currentRoute.name == "project-create") {
        projectData.value = project;
        loading.value = false
      } else {
        store
          .dispatch("project/fetchProject", { id: router.currentRoute.params.id })
          .then((response) => {
            projectData.value = response.data.project;
            
            loading.value = false
          })
          .catch((error) => {
            console.log("error when fetching project", error);
            if (error.response.status === 404) {
              projectData.value = undefined;
            }
            loading.value = false
          });
      }
    };
    const projectStatusesOptions = ref([]);
    const quotationOptions = ref([]);
    const invoiceOptions = ref([]);
    const paymentMethodOptions = ref([]);
    const customerOptions = ref([]);
    const productOptions = ref([]);
    const productUnitOptions = ref([]);
    const productCategoriesOptions = ref([]);
    const stageOptions = ref([])
    const userOptions = ref([])

    const refetchOption = () => {
      loading.value =true;
      store
        .dispatch("app/fetchOptionList", {
          project_statuses: true,
          min_quotations: true,
          payment_methods: true,
          customers: true,
          products: true,
          product_units: true,
          product_categories: true,
          stages: true,
          users: true,
          invoices: true
        })
        .then((response) => {
          projectStatusesOptions.value = response.data.project_statuses;
          quotationOptions.value = response.data.quotations;
          invoiceOptions.value = response.data.invoices;
          paymentMethodOptions.value = response.data.payment_methods;
          customerOptions.value = response.data.customers
          productOptions.value = response.data.products;
          productUnitOptions.value = response.data.product_units;
          productCategoriesOptions.value = response.data.product_categories;
          stageOptions.value = response.data.stages
          userOptions.value = response.data.users.filter(ele => ele.user_type_id == 1 || ele.user_type_id == 4)
          refetchData();
        })
        .catch((error) => {
          loading.value = false
        });
    };


    onMounted(() => {
      refetchOption();
    });

    return {
      refetchData,
      projectData,
      projectStatusesOptions,
      paymentMethodOptions,
      customerOptions,
      quotationOptions,
      invoiceOptions,
      productOptions,
      productUnitOptions,
      productCategoriesOptions,
      stageOptions,
      loading,
      refetchOption,
      userOptions
    };
  },
};
</script>
